import { render, staticRenderFns } from "./ChartDialog.vue?vue&type=template&id=06383b3a"
import script from "./ChartDialog.vue?vue&type=script&lang=js"
export * from "./ChartDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports